import { LoginResponse } from "app/api/busha/types";
import Page from "app/components/Page";
import LoginForm from "./components/LoginForm";
import React from "react";
import OtpForm from "./components/OtpForm";
import { useNavigate } from "react-router-dom";
import { BUSHA_ROOT, BUSHA_TRANSFER_CONFIRM_PAGE } from "app/constants/routes";
import { AppStateActions, useAppDispatch } from "app/providers/AppStateProvider";

export type loginDataType = LoginResponse & { email: string };

export default function BushaLogin() {
  const navigate = useNavigate();
  const [loginResponse, setLoginResponse] = React.useState<loginDataType>();
  const [activeView, setActiveView] = React.useState<"login" | "verify">(
    "login"
  );

  const dispatch = useAppDispatch();

  return (
    <Page onBack={() => activeView === "login" ? navigate(-1) : setActiveView("login")}>

      {activeView === "login" && (
        <LoginForm
          onDone={(response?: loginDataType) => {
            setLoginResponse(response);
            if (response?.status === "two_step") {
              setActiveView("verify");
            } else if (response?.access_token) {
              dispatch({
                type: AppStateActions.setBushaAuthToken,
                payload: response.access_token,
              });

              navigate(`${BUSHA_ROOT}/${BUSHA_TRANSFER_CONFIRM_PAGE}`, { replace: true });
            }
          }}
        />
      )}

      {activeView === "verify" && (
        <OtpForm initializationData={loginResponse!} />
      )}
    </Page>
  );
}
